module.exports = __webpack_public_path__ + "static/img/accessEvent.9d9379f3.png";